const getFilterSectionStyles = theme => ({
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(0)
});
const getFilterSectionFieldStyles = theme => ({
  paddingBottom: theme.spacing(3)
});
const getCategoryTitleStyles = someSelectedCourier => theme => ({
  color: someSelectedCourier ? theme.palette.black : theme.palette.gray.dark
});
const getLabelWithIconStyles = theme => ({
  display: 'flex',
  gap: theme.spacing(),
  alignItems: 'flex-start'
});
const getIconStyles = theme => ({
  marginTop: theme.spacing(0.25)
});

export { getCategoryTitleStyles, getFilterSectionFieldStyles, getFilterSectionStyles, getIconStyles, getLabelWithIconStyles };
//# sourceMappingURL=FilterSectionStyles.js.map
